function e(e,t,n){const r={};return Object.keys(e).forEach((u=>{r[u]=e[u].reduce(((e,r)=>{if(r){const u=t(r);""!==u&&e.push(u),n&&n[r]&&e.push(n[r])}return e}),[]).join(" ")})),r}export{e as default};
//# sourceMappingURL=composeClasses.js.map
